import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord, requirePermission } from '@/app/guards';
import { RolePage, roleQuery } from '@/features/admin';
import { NotFoundView } from '@/features/shell';

/** A role record page (outside the admin tabs): header, scope summary and the permission editor. */
export const Route = createFileRoute('/_app/admin_/roles/$roleId')({
  staticData: { crumbParents: [{ crumb: 'nav.setup', to: '/setup' }, { crumb: 'admin:nav.roles', to: '/admin/roles' }] },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'admin.roles', 'Setup'),
  loader: async ({ context, params }) => {
    const r = await ensureRecord(context.queryClient.query({ ...roleQuery(params.roleId), staleTime: 'static' }));
    return { crumb: r.name };
  },
  notFoundComponent: function RoleNotFound() {
    const { roleId } = Route.useParams();
    return <NotFoundView reference={roleId} />;
  },
  component: function Role() {
    const { roleId } = Route.useParams();
    const navigate = Route.useNavigate();
    return <RolePage roleId={roleId} onCreated={(id) => void navigate({ to: '/admin/roles/$roleId', params: { roleId: id } })} />;
  },
});
